/**
 * recentChecks.js — localStorage helpers for the "Your recent checks" homepage
 * section. Keeps the last 5 anonymous checks so users can re-run them in one
 * tap.
 *
 * Storage key: `blendsafe_recent_checks_v1`
 * Schema (per entry):
 *   {
 *     med_id, med_name,
 *     product_id, product_name,
 *     verdict,                // SAFE_TOGETHER | USE_WITH_CAUTION | AVOID | INSUFFICIENT_DATA
 *     safety_score,           // 0..100
 *     checked_at,             // ISO string
 *   }
 */
const KEY = "blendsafe_recent_checks_v1";
const MAX = 5;

const safeParse = (raw) => {
  try {
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

export function getRecentChecks() {
  try {
    return safeParse(localStorage.getItem(KEY));
  } catch {
    return [];
  }
}

export function addRecentCheck(entry) {
  if (!entry || !entry.med_id || !entry.product_name) return;
  try {
    const list = getRecentChecks();
    // Dedupe by (med_id, product_id || product_name) — newest wins.
    const dedupKey = `${entry.med_id}::${entry.product_id || entry.product_name}`;
    const filtered = list.filter(
      (e) => `${e.med_id}::${e.product_id || e.product_name}` !== dedupKey,
    );
    filtered.unshift({
      med_id: entry.med_id,
      med_name: entry.med_name || entry.med_id,
      product_id: entry.product_id || null,
      product_name: entry.product_name,
      verdict: entry.verdict || "INSUFFICIENT_DATA",
      safety_score:
        typeof entry.safety_score === "number" ? entry.safety_score : null,
      checked_at: new Date().toISOString(),
    });
    localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, MAX)));
  } catch {
    /* storage blocked — silent */
  }
}

export function clearRecentChecks() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
}
